import { servicesService } from "../../services/servicesService";
import {
  buildLocksmithFormData,
  emptyLocksmithInvoiceForm,
  filterParams,
} from "./funciones";
import { NO_RECOMMENDED_PROVIDER, PaymentStatus } from "./options";

// Valores iniciales del modal de pago de cerrajeria (Registrar Pago)
export const setLocksmithPaymentDefaults = (setValue) => {
  setValue("isLocksmith", true);
  setValue("paymentStatus", PaymentStatus?.N_A);
  setValue("price", "");
  setValue("pvp", 0);
  Object.entries(emptyLocksmithInvoiceForm).forEach(([field, value]) =>
    setValue(field, value)
  );
};

// Guarda costo y factura en PUT /services/:serviceId/updateLocksmith
export const saveLocksmithAfterCreate = async (serviceId, data) => {
  if (!serviceId) {
    return { ok: false };
  }
  const response = await servicesService.updateLocksmith(
    buildLocksmithFormData(data),
    serviceId
  );
  return { ok: [200, 201].includes(response?.status), response };
};

const hasLocksmithPaymentData = (data) =>
  data?.withInvoice === true ||
  (data?.price !== undefined && data?.price !== null && data?.price !== "");

// Cerrajeria no usa createAv: se crea con POST /services/createLocksmith { case, provider }
// Sin proveedor recomendado se omite provider del body
export const createLocksmithService = async ({ caseId, provider, data }) => {
  const response = await servicesService.createLocksmith(
    filterParams({
      case: caseId,
      provider: provider === NO_RECOMMENDED_PROVIDER ? undefined : provider,
    })
  );
  if (![200, 201].includes(response?.status)) {
    return { created: false, saved: false, response };
  }
  if (!hasLocksmithPaymentData(data)) {
    return { created: true, saved: true, response };
  }
  const { ok } = await saveLocksmithAfterCreate(
    response?.data?.serviceId,
    data
  ).catch(() => ({
    ok: false,
  }));
  return { created: true, saved: ok, response };
};
